"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _find = _interopRequireDefault(require("lodash/find"));

var _split = _interopRequireDefault(require("lodash/split"));

var _last = _interopRequireDefault(require("lodash/last"));

var _pick = _interopRequireDefault(require("lodash/pick"));

var _fieldResolver = _interopRequireDefault(require("./../helpers/field-resolver"));

var _propertyEditorInternalContext = _interopRequireDefault(require("./../contexts/property-editor-internal-context"));

var _propertyEditorContext = _interopRequireDefault(require("./../contexts/property-editor-context"));

var _Skeleton = _interopRequireDefault(require("@eig-builder/core-ui/Skeleton"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  margin-top: ", "px !important;\n  margin-bottom: ", "px !important;\n  margin-left: ", "px;\n  width: calc(100% - ", "px);\n  height: 40px !important;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledSkeleton = (0, _styledComponents["default"])(_Skeleton["default"])(_templateObject(), function (props) {
  return props.theme.spacing(2);
}, function (props) {
  return props.theme.spacing(2);
}, function (props) {
  return props.theme.spacing(4);
}, function (props) {
  return props.theme.spacing(4);
});

var FieldPortal = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(FieldPortal, _PureComponent);

  var _super = _createSuper(FieldPortal);

  function FieldPortal() {
    (0, _classCallCheck2["default"])(this, FieldPortal);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(FieldPortal, [{
    key: "render",
    value: function render() {
      var _this = this;

      var field = (0, _find["default"])(this.context.fields, function (field) {
        return field.fieldId === _this.props.name;
      });

      if (this.props.skeletonLoader && this.context.schemaIsLoading) {
        var fieldProps = (0, _pick["default"])(this.props, ['className']); // Skeletons only get displayed when the property editor has Fields as children (generate false)

        return /*#__PURE__*/_react["default"].createElement("div", fieldProps, /*#__PURE__*/_react["default"].createElement(StyledSkeleton, null));
      }

      if (!field) {
        // it might be a grouped field
        field = (0, _find["default"])(this.context.fields, function (field) {
          return (0, _last["default"])((0, _split["default"])(field.fieldId, '.')) === _this.props.name;
        });
      }

      var currentValue;

      if (field) {
        currentValue = this.context.fieldPortalValuesOnlyUseForFieldPortalsAllOtherUseCasesWillBreakTheControlledPropertyEditor[field.fieldId];

        var fieldWithProps = _objectSpread(_objectSpread(_objectSpread({}, field), this.props), {}, {
          dataElementLocation: this.context.dataElementLocation,
          dataElementLabel: this.context.dataElementLabelPrefix,
          dataElementId: this.context.dataElementIdPrefix
        });

        return _fieldResolver["default"].resolve(fieldWithProps, currentValue, this.context.additionalFieldTypes);
      }

      return null;
    }
  }]);
  return FieldPortal;
}(_react.PureComponent);

FieldPortal.propTypes = {
  name: _propTypes["default"].string.isRequired,
  skeletonLoader: _propTypes["default"].bool.isRequired
};
FieldPortal.contextType = _propertyEditorInternalContext["default"];

var FieldPortalWrapper = function FieldPortalWrapper(props) {
  var _useContext = (0, _react.useContext)(_propertyEditorContext["default"]),
      skeletonLoader = _useContext.skeletonLoader;

  return /*#__PURE__*/_react["default"].createElement(FieldPortal, (0, _extends2["default"])({}, props, {
    skeletonLoader: skeletonLoader
  }));
};

FieldPortalWrapper.propTypes = {
  name: _propTypes["default"].string.isRequired
};
var _default = FieldPortalWrapper;
exports["default"] = _default;